import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { bindActionCreators } from 'redux';
import { Field } from 'redux-form';
import { RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import { CSSTransitionGroup } from 'react-transition-group';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import { RenderError, RenderGhostError } from 'components/shared/RenderError';

import * as validator from 'helpers/Validator';

const studentOnlyGuarantor = ['student_only_guarantor', 'student_guarantor_mandatory_generic_link'];
class AddApplicantForm extends Component {
  componentDidMount() {
    const { changeFieldValue, name, applicationType } = this.props;

    let defaultGuarantorValue = 'No';
    if (studentOnlyGuarantor.includes(applicationType)) {
      defaultGuarantorValue = 'Yes';
    }
    changeFieldValue(`${name}.guarantor`, defaultGuarantorValue);
  }

  render() {
    const { name, index } = this.props;

    const styles = {
      field: { fontSize: '14px', width: '100%' },
    };

    const onlyGuarantor = studentOnlyGuarantor.includes(this.props.applicationType);

    return (
      <div>
        <CSSTransitionGroup
          transitionName="add_applicant"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
        >
          <div key={`applicant_form_${index}`}>
            <div className="row" style={{ marginTop: '20px' }}>
              <input type="disable_auto_complete" value="disable_auto_complete" hidden />
              <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Field
                  name={`${name}.first_name`}
                  type="text"
                  component={TextField}
                  label="First Name"
                  validate={[validator.required]}
                  style={styles.field}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Field
                  name={`${name}.last_name`}
                  type="text"
                  component={TextField}
                  label="Last Name"
                  validate={[validator.required]}
                  style={styles.field}
                  variant="outlined"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Field
                  name={`${name}.email`}
                  type="text"
                  component={TextField}
                  autoComplete="do_not_show_autocomplete"
                  label="Email"
                  validate={[validator.required, validator.validEmail]}
                  style={styles.field}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginBottom: '20px' }}>
                <Field
                  name={`${name}.phone_number`}
                  type="text"
                  component={ReactPhoneInput}
                  label="Phone Number"
                  validate={[validator.required, validator.validInternationalPhoneNumber]}
                  style={styles.field}
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px', textAlign: 'center' }}>
              <p> Is he/she a Guarantor? </p>
              <Field name={`${name}.guarantor`} component={RadioButtonGroup}>
                <RadioButton
                  disabled={onlyGuarantor}
                  value="Yes"
                  label="Yes"
                  style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
                />
                <RadioButton
                  disabled={onlyGuarantor}
                  value="No"
                  label="No"
                  style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
                />
              </Field>
              <Field name={`${name}.guarantor`} component={RenderError} />
              <Field name={`${name}.guarantor`} component={RenderGhostError} />
            </div>
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

AddApplicantForm = connect(
  (store) => ({
    applicationType: store.applicationStatus.application_type,
  }),
  (dispatch, ownProps) =>
    bindActionCreators(
      {
        changeFieldValue: (field, value) => change(ownProps.formName, field, value),
      },
      dispatch
    )
)(AddApplicantForm);

export default AddApplicantForm;
